<script setup>
/* eslint-disable */
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  }
});

const emit = defineEmits(["update:modelValue"]);

</script>

<template>
  <svg
    v-if="modelValue"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
      fill="#F7F8FD"
      stroke="#1F9AFF"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.99984 13.3332C11.8408 13.3332 13.3332 11.8408 13.3332 9.99984C13.3332 8.15889 11.8408 6.6665 9.99984 6.6665C8.15889 6.6665 6.6665 8.15889 6.6665 9.99984C6.6665 11.8408 8.15889 13.3332 9.99984 13.3332Z"
      fill="#1F9AFF"
      stroke="#1F9AFF"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    v-else
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
      fill="#F7F8FD"
      stroke="#CACACA"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped lang="scss">
svg {
  cursor: pointer;
  user-select: none;
}
</style>